import { render, staticRenderFns } from "./GridListProduct.vue?vue&type=template&id=c4f0a916&scoped=true&"
import script from "./GridListProduct.vue?vue&type=script&lang=js&"
export * from "./GridListProduct.vue?vue&type=script&lang=js&"
import style0 from "./GridListProduct.vue?vue&type=style&index=0&id=c4f0a916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f0a916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
